import styled from 'styled-components'

export const AnalysisBalanceValue = (props: {
  native: React.ReactNode
  usd: React.ReactNode
}) => {
  return (
    <Root>
      <NativeBalance>{props.native}</NativeBalance>&nbsp;
      <UsdBalance>{props.usd}</UsdBalance>
    </Root>
  )
}
const Root = styled.div`
  display: flex;
  color: var(--text-12);
`
const NativeBalance = styled.div``

const UsdBalance = styled.div`
  color: var(--text-11);
`
